import styled from 'styled-components';
import { SelectContainer } from '../../../ui/atoms/CustomSelect/style';

export const TabsWrapper = styled.div`
  margin-top: 40px;

  @media ${(props) => props.theme.device.mobileL} {
    margin-top: 32px;
  }
`;

export const TabsWrapperMobile = styled(TabsWrapper)`
  border-bottom: 2px solid ${(props) => props.theme.colors.link};
  padding: 16px 24px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: ${(props) => props.theme.colors.link};

  ${SelectContainer} {
    width: unset;
  }

  div[class*='-control'] {
    border: none;
    width: fit-content;
  }

  div[class*='singleValue'] {
    color: ${(props) => props.theme.colors.link} !important;
    text-align: end;
  }

  div[class*='menu'] {
    min-width: 200px;
    right: 0;
  }
`;

export const TabContent = styled.div`
  display: none;
  &.active {
    display: block;
  }
`;
